"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.configPro = exports.configPre = exports.configDev = void 0;
var COLLECTOR_PATH = 'api/v1/track';
var endpointsCollector = {
    DEV: {
        URL: 'https://collector.pulse-internal-dev.schibsted.io',
        PATH: COLLECTOR_PATH,
    },
    PRE: {
        URL: 'https://collector.pulse-internal-pre.schibsted.io',
        PATH: COLLECTOR_PATH,
    },
    PRO: {
        URL: 'https://collector.schibsted.io',
        PATH: COLLECTOR_PATH,
    },
};
var endpointsCis = {
    DEV: {
        URL: 'https://cis.pulse-internal-dev.schibsted.io',
    },
    PRE: {
        URL: 'https://cis.pulse-internal-pre.schibsted.io',
    },
    PRO: {
        URL: 'https://cis.schibsted.com',
    },
};
var baseConfig = {
    cisEnabled: true,
    eventDebounce: 200,
    environment: 'browser',
    useBeaconWhenAvailable: true,
};
exports.configDev = __assign(__assign({}, baseConfig), { cisBaseUrl: endpointsCis.DEV.URL, collectorBaseUrl: endpointsCollector.DEV.URL, collectorPath: endpointsCollector.DEV.PATH });
exports.configPre = __assign(__assign({}, baseConfig), { cisBaseUrl: endpointsCis.PRE.URL, collectorBaseUrl: endpointsCollector.PRE.URL, collectorPath: endpointsCollector.PRE.PATH });
exports.configPro = __assign(__assign({}, baseConfig), { cisBaseUrl: endpointsCis.PRO.URL, collectorBaseUrl: endpointsCollector.PRO.URL, collectorPath: endpointsCollector.PRO.PATH });
exports.default = exports.configPro;
